function checkNavigator(testExp: RegExp): boolean {
  // Depending on the execution environment, navigator might either be undefined or throw a ReferenceError.
  try {
    return testExp.test(navigator.userAgent);
  } catch {
    return false;
  }
}

export const isIE = checkNavigator(/Trident/);

